import React, { useState } from 'react';
import { css } from 'linaria';
import cn from 'clsx';

import AppLink from '../../AppLink';

const MAX_NODES_HAS_BELOW = 5;
const MAX_NODES_NO_BELOW = 8;

const HasHiddenNodes = css`
  li:nth-child(n + ${MAX_NODES_NO_BELOW + 3}) {
    display: none;
  }

  &.has-content-below li:nth-child(n + ${MAX_NODES_HAS_BELOW + 3}) {
    display: none;
  }
`;

interface Node {
  id: number;
  title: string;
  customUrl: string;
  type: string;
  slug: string;
  navLevel: any;
  onNavFinished: any;
}

const getNodeURL = ({ customUrl, slug, type }: Node) =>
  customUrl && customUrl.length > 0 ? customUrl : `/cards/${type}/${slug}`;
const trackingProps = { block_name: 'category_nav', block_row: 'category_nav' };

const NavGroupContent = (props: any) => {
  const {
    childNodes,
    className,
    hasContentBelow,
    navLevel,
    node,
    node: { title },
    onNavFinished,
  } = props;
  const [isContentHidden, setIsContentHidden] = useState(true);
  const maxNodes = hasContentBelow ? MAX_NODES_HAS_BELOW : MAX_NODES_NO_BELOW;

  const displayNodes =
    childNodes.length <= maxNodes + 1 ? childNodes : childNodes.slice(0, maxNodes);
  const hiddenNodes = childNodes.length <= maxNodes + 1 ? [] : childNodes.slice(maxNodes);

  const newNavLevel = [...navLevel, title];

  return (
    <ul
      className={cn(
        className,
        'space-y-1',
        isContentHidden ? HasHiddenNodes : null,
        hasContentBelow ? 'has-content-below' : null
      )}
    >
      <li>
        <AppLink
          className="text-lapel hover:text-black font-bold"
          href={getNodeURL(node)}
          onClick={(event: any) => onNavFinished(event, newNavLevel)}
          tracking={{ id: title, ...trackingProps }}
        >
          {title}
        </AppLink>
      </li>
      {displayNodes.map((visibleNode: Node) => (
        <li className="text-lapel hover:text-black" key={visibleNode.id}>
          <AppLink
            href={getNodeURL(visibleNode)}
            onClick={(event: any) => onNavFinished(event, [...newNavLevel, visibleNode.title])}
            tracking={{ id: visibleNode.title, ...trackingProps }}
          >
            {visibleNode.title}
          </AppLink>
        </li>
      ))}
      {isContentHidden && hiddenNodes.length > 0 && (
        <li>
          <span
            className="border-b border-gatsby text-gatsby hover:text-dark-blue tracked-small"
            onClick={() => setIsContentHidden(false)}
          >
            More
          </span>
        </li>
      )}
      {hiddenNodes.map((hiddenNode: Node) => (
        <li className="text-lapel" key={hiddenNode.id}>
          <AppLink
            href={getNodeURL(hiddenNode)}
            onClick={(event: any) => onNavFinished(event, [...newNavLevel, hiddenNode.title])}
            tracking={{ id: hiddenNode.title, ...trackingProps }}
          >
            {hiddenNode.title}
          </AppLink>
        </li>
      ))}
    </ul>
  );
};

export default NavGroupContent;
